import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24Like2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M15.382 4.007a5.76 5.76 0 0 0-3.465 1.372l-.1.088-.134-.12A5.75 5.75 0 0 0 7.976 4a5.76 5.76 0 0 0-4.138 1.754 6.56 6.56 0 0 0-.452 8.586l.167.205a24 24 0 0 0 1.658 1.843l.475.473.244.234.497.465.505.454q.38.337.761.653l.505.41.249.195.49.37c1.127.828 2.127 1.397 2.733 1.462l.106.005h.08l.106-.005c.822-.088 2.372-1.104 3.98-2.44l.508-.432.508-.448q.253-.228.503-.462l.492-.47.477-.474.232-.237.446-.473q.435-.47.808-.922l.181-.222c2.157-2.548 2.034-6.345-.3-8.769A5.76 5.76 0 0 0 15.656 4zM15.656 6a3.76 3.76 0 0 1 2.702 1.145 4.56 4.56 0 0 1 .34 5.927l-.297.367c-.33.399-.718.825-1.138 1.259l-.43.435-.446.434-.456.43-.23.212-.462.415-.458.398q-.113.098-.225.192l-.442.365-.425.338-.4.305-.19.14-.357.247c-.338.227-.62.388-.822.462l-.105.031-.102-.03c-.293-.108-.757-.4-1.315-.81l-.385-.29-.202-.158-.416-.335-.432-.36-.442-.381-.222-.197-.447-.403-.444-.414-.435-.419-.422-.42-.205-.21-.392-.414a22 22 0 0 1-.367-.405l-.335-.392-.155-.19a4.567 4.567 0 0 1 .18-6.13 3.76 3.76 0 0 1 5.4 0l1.14 1.034 1.09-.987C13.663 6.413 14.637 6 15.657 6z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Like2$1 = Svg24Like2;

export { Svg24Like2$1 as default };
